<template>
  <div class="h-full flex items-center">
    <el-select
      ref="personSelect"
      popper-class="hidden"
      size="small"
      :placeholder="placeholder"
      multiple
      filterable
      allow-create
      default-first-option
      v-model="name"
      clearable
      @clear="clearName"
      class="flex-1"
      @focus="focus"
      @remove-tag="removeTag"
    >
      <el-option
        v-for="item in selectData"
        :key="item.id"
        :value="item.id"
        :label="item.label"
      ></el-option>
    </el-select>
    <button
      class="handle_btn search ml-10px"
      :disabled="disabled"
      type="button"
      @click="initDialog"
    >
      选择人员
    </button>
    <div class="fixed inset-0 z-1000" @click.stop v-show="visible">
      <CockpitDialog
        title="选择应急预案"
        left="580px"
        width="990px"
        height="650px"
        top="120px"
        @close="visible = false"
      >
        <el-row :gutter="10" class="h-full">
          <el-col :span="12" class="h-full">
            <div class="h-full px-10px ">
              <el-input
                placeholder="请输入"
                class="inline-block"
                prefix-icon="el-icon-search"
                v-model="treeKeyword"
                clearable
              />
              <el-tree
                :data="treeData"
                :props="treeProps"
                :node-key="treeNodeKey"
                :default-expanded-keys="treeExpandedKeys"
                highlight-current
                ref="tree"
                class="overflow-y-auto h-[calc(100%-66px)] mt-10px border-1px border-[#184C5C]"
                :show-checkbox="!disabled"
                :filter-node-method="filterTree"
                @check="nodeChecked"
              >
                <div
                  slot-scope="{ node }"
                  class="overflow-x-hidden flex-1 flex items-center justify-between"
                >
                  <el-tooltip effect="dark" :content="node.label" placement="top">
                    <span class="truncate inline-block tree-item">{{ node.label }}</span>
                  </el-tooltip>
                </div>
              </el-tree>
            </div>
          </el-col>
          <el-col :span="12" class="h-full">
            <div
              class="h-[calc(100%-15px)] px-20px pt-10px border-[#2F7075] border-l-1px border-solid"
            >
              <div class="text-16px mb-20px">已选择：{{ selectData.length }}</div>
              <div class="h-[calc(100%-74px)] overflow-y-auto">
                <div
                  v-for="(item, index) in selectData"
                  :key="index"
                  class="h-24px flex justify-between items-center"
                >
                  <span class="flex-1 mr-10px truncate">{{ item.label }}</span>
                  <span
                    v-if="!disabled"
                    class="iconfont icon-line-close text-14px cursor-pointer"
                    @click="removeItem(item, index)"
                  ></span>
                </div>
              </div>
              <div class="flex justify-center" v-if="!disabled">
                <button class="handle_btn !bg-[#4dc2d2] mr-10px" type="button" @click="save()">
                  创建
                </button>
                <button class="handle_btn !bg-[#CFC929] mr-10px" type="button" @click="clear()">
                  清空
                </button>
                <button class="handle_btn mr-10px" type="button" @click="cancel()">
                  取消
                </button>
              </div>
            </div>
          </el-col>
        </el-row>
      </CockpitDialog>
    </div>
  </div>
</template>

<script>
import { PlanApi } from '@wiz-api/emergency-management'
// import utils from '@/components/safety/enumField/utils'
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import { EafOrganizationUnitUserApi } from '@wiz-api/account'

const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()

const planApi = new PlanApi()
export default {
  name: 'cockpit-person-select',
  components: {
    CockpitDialog,
  },

  props: {
    placeholder: {
      default: '请选择人员',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      default: '',
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      name: [],
      visible: false,
      treeData: [],
      treeLoading: false,
      treeKeyword: '',
      treeProps: {
        children: 'childen',
        label: 'label',
        disabled: this.treeDisabled,
      },
      treeNodeKey: 'keyId',
      treeExpandedKeys: [],
      selectData: [],
      organizationIds: [],
    }
  },
  async created() {
    await this.getUserTree()
    // 需要获取树结构才能获取名称，value不做监听，获取表单数据后调用setUserName方法
    if (this.value) {
      this.setUserName()
    }
  },
  computed: {},
  watch: {
    treeKeyword(val) {
      this.$refs.tree.filter(val)
    },
  },
  methods: {
    removeTag(value) {
      this.$emit('change', this.name.join())
    },
    focus() {
      this.$nextTick(() => {
        this.$refs.personSelect.blur()
      })
    },
    nodeChecked() {
      // organizationUnitId 子节点全部勾选会勾选子节点
      const checkedNodes = this.$refs.tree.getCheckedNodes()
      this.selectData = checkedNodes.reduce((pre, item) => {
        const userId = item.keyId.split('_')[1]
        const isHas = pre.every((i) => {
          return !(i.keyId.indexOf(userId) > -1)
        })
        if (isHas && !item.organizationUnitId) {
          pre.push(item)
        }
        return pre
      }, [])
      const checkedIds = checkedNodes.reduce((pre, item) => {
        if (!item.organizationUnitId) {
          const organizationIds = this.organizationIds.map((organizationId) => {
            const userId = item.keyId.split('_')[1]
            return `${organizationId}_${userId}`
          })
          pre.push(...organizationIds)
        }
        return pre
      }, [])
      this.$refs.tree.setCheckedKeys(checkedIds)
    },
    treeDisabled(data, node) {
      return data.organizationUnitId
    },
    dealUserTree(treeData) {
      _.forEach(treeData, (treeItem) => {
        if (treeItem.childen) {
          this.organizationIds.push(treeItem.organizationUnitId)
          treeItem.keyId = treeItem.organizationUnitId
          treeItem.label = treeItem.organizationUnitName
          if (treeItem.userList) {
            _.forEach(treeItem.userList, (userItem) => {
              userItem.keyId = `${treeItem.organizationUnitId}_${userItem.id}`
              userItem.label = userItem.name
            })
            treeItem.childen.push(...treeItem.userList)
            delete treeItem.userList
          }
          this.dealUserTree(treeItem.childen)
        }
      })
    },
    filterTree(value, data) {
      if (!value) return true
      return data.label?.includes(value)
    },
    removeItem(i, index) {
      this.selectData.splice(index, 1)

      const checkedIds = this.selectData.reduce((pre, item) => {
        if (!item.organizationUnitId) {
          const organizationIds = this.organizationIds.map((organizationId) => {
            const userId = item.keyId.split('_')[1]
            return `${organizationId}_${userId}`
          })
          pre.push(...organizationIds)
        }
        return pre
      }, [])
      this.$refs.tree.setCheckedKeys(checkedIds)
    },
    async getUserTree() {
      this.treeLoading = true
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserTree({
        outputPost: true,
      })
      if (!err) {
        const treeData = res
        this.dealUserTree(treeData)
        this.treeData = treeData
        // 展开根节点
        this.treeExpandedKeys = [this.treeData[0].organizationUnitId]
      }
      this.treeLoading = false
    },
    async setUserName() {
      if (!this.value) {
        this.clear()
        return
      }
      const userIds = this.value.split(',')
      const checkedIds = userIds.reduce((pre, userId) => {
        const organizationIds = this.organizationIds.map((organizationId) => {
          return `${organizationId}_${userId}`
        })
        pre.push(...organizationIds)
        return pre
      }, [])
      this.$refs.tree.setCheckedKeys(checkedIds)
      const checkedNodes = this.$refs.tree.getCheckedNodes()
      this.selectData = checkedNodes.reduce((pre, item) => {
        const userId = item.keyId.split('_')[1]
        const isHas = pre.every((i) => {
          return !(i.keyId.indexOf(userId) > -1)
        })
        if (isHas && !item.organizationUnitId) {
          pre.push(item)
        }
        return pre
      }, [])

      this.name = userIds
    },
    clearName() {
      this.$emit('change', '')
    },
    // 初始化弹窗
    initDialog() {
      this.setUserName()
      this.visible = true
    },
    cancel(done) {
      this.treeKeyword = ''
      this.clear()
      if (done) {
        done()
      } else {
        this.visible = false
      }
    },
    save() {
      this.name = this.selectData.map((item) => {
        return item.id
      })
      this.$emit('change', this.name.join(','))
      this.cancel()
    },
    clear() {
      this.selectData = []
      this.$refs.tree.setCheckedKeys([])
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-tree {
  overflow-y: scroll;
  &-node__label {
    font-size: 12px;
    color: #fff;
  }
  &-node__content {
    height: 28px;
  }
  &__empty-text {
    font-size: 12px;
    color: #fff !important;
  }
  .is-current {
    .el-tree-node__children .el-tree-node__label {
      color: #fff;
    }
  }
  .tree-item {
    color: #fff;
  }
  .is-disabled {
    display: none;
  }
}
::v-deep .el-tree,
::v-deep .el-tree-node:focus > .el-tree-node__content,
::v-deep .el-tree-node:focus,
::v-deep .el-tree-node__content:hover,
::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: transparent;
}
::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: rgba(0, 116, 201, 0.4);
  color: #00c0ff;
}
::v-deep .el-tag {
  background: transparent !important;
  border: 0 !important;
  .el-select__tags-text {
    color: var(--cockpitInputFontColor);
  }
  .el-tag__close {
    background: #45f2eb;
  }
}
.handle_btn {
  height: 32px;
  width: 96px;
  border-radius: 32px;
  background: linear-gradient(180deg, #137ee566 0%, #19a4da66 100%),
    linear-gradient(-180deg, #05bdff00 0%, #3bfff566 100%);
  box-shadow: inset 0px 1px 15px 0px #77c4ff33;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
}
.search {
  background: #4dc2d2;
}
.handle_btn[disabled] {
  cursor: no-drop;
}
::v-deep .el-input__validateIcon {
  display: none;
}
</style>
